/** Injectable CMP gate for PostHog (breaks analyticsConsent ↔ postHogProfile import cycle). */

let captureAllowedChecker = () => false;

export function setPostHogCaptureAllowedChecker(checker) {
  captureAllowedChecker = typeof checker === 'function' ? checker : () => false;
}

export function isPostHogCaptureAllowedByCmp() {
  return captureAllowedChecker();
}

/** @internal */
export function resetPostHogConsentGateForTests() {
  captureAllowedChecker = () => false;
}
